module.exports = __webpack_public_path__ + "img/logo-email.494ffd94.png";